var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutiveCommandCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3987 9.26288C12.0267 10.1428 11.4449 10.9182 10.7041 11.5213C9.96336 12.1244 9.08618 12.5367 8.14928 12.7224C7.21238 12.908 6.24429 12.8612 5.32965 12.5861C4.415 12.311 3.58165 11.8159 2.90245 11.1443C2.22325 10.4726 1.71888 9.64467 1.43343 8.73295C1.14799 7.82123 1.09017 6.85344 1.26502 5.9142C1.43987 4.97496 1.84206 4.09287 2.43645 3.34503C3.03083 2.5972 3.79931 2.0064 4.67469 1.62428M12.2757 6.98787C12.5984 6.98787 12.8633 6.72526 12.8311 6.40416C12.6963 5.06136 12.1015 3.80651 11.1474 2.85234C10.1933 1.89817 8.93868 1.3034 7.59625 1.16885C7.27466 1.13668 7.01271 1.40164 7.01271 1.72449V6.40357C7.01271 6.55869 7.07432 6.70746 7.18397 6.81715C7.29363 6.92684 7.44235 6.98846 7.59742 6.98846L12.2757 6.98787Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutiveCommandCenter);
export default __webpack_public_path__ + "static/media/Executive-Command-Center.01fcaeea357f6c468f0eddd892c7a9ac.svg";
export { ForwardRef as ReactComponent };